import React from 'react';
import { useNavigate, Routes, Route } from 'react-router-dom';
import { FaProjectDiagram } from '@react-icons/all-files/fa/FaProjectDiagram';
import { FaLayerGroup } from '@react-icons/all-files/fa/FaLayerGroup';
import { FaSitemap } from '@react-icons/all-files/fa/FaSitemap';
import { FaCircle } from '@react-icons/all-files/fa/FaCircle';
import { FaStream } from '@react-icons/all-files/fa/FaStream';
import { FaDotCircle } from '@react-icons/all-files/fa/FaDotCircle';
import { FaTags } from '@react-icons/all-files/fa/FaTags';
import { FaBuilding } from '@react-icons/all-files/fa/FaBuilding';
import { FaNetworkWired } from '@react-icons/all-files/fa/FaNetworkWired';
import { FaPencilRuler } from '@react-icons/all-files/fa/FaPencilRuler';
import { FaDraftingCompass } from '@react-icons/all-files/fa/FaDraftingCompass';
import { FaLink } from '@react-icons/all-files/fa/FaLink';
import { FaToggleOn } from '@react-icons/all-files/fa/FaToggleOn';
import { FaClipboardCheck } from '@react-icons/all-files/fa/FaClipboardCheck';
import { FaFolderOpen } from '@react-icons/all-files/fa/FaFolderOpen';
import { FaCog } from '@react-icons/all-files/fa/FaCog';
import { FaHome } from '@react-icons/all-files/fa/FaHome';
import Breadcrumb from '../../../commons/Breadcrumb';
import TileContainer, { TileItem } from '../../../commons/TileContainer';
import ClasePage from './clase/clase-page';
import ClaseFormPage from './clase/clase-form-page';
import WorkflowDefPage from './definicion-workflow/workflow-def-page';
import WorkflowDefFormPage from './definicion-workflow/workflow-def-form-page';
import WorkflowDisenoPage from './definicion-workflow/workflow-diseno-page';
import TipoActividadPage from './tipo-actividad/tipo-actividad-page';
import TipoActividadFormPage from './tipo-actividad/tipo-actividad-form-page';
import CategoriaActividadPage from './categoria-actividad/categoria-actividad-page';
import CategoriaActividadFormPage from './categoria-actividad/categoria-actividad-form-page';
import WorkflowEmpresaPage from './workflow-empresa/workflow-empresa-page';
import WorkflowEmpresaFormPage from './workflow-empresa/workflow-empresa-form-page';
import WorkflowDisenoListPage from './workflow-diseno/workflow-diseno-page';
import WorkflowDisenoFormPage from './workflow-diseno/workflow-diseno-form-page';
import WorkflowEmpresaDisenoListPage from './workflow-empresa-diseno/workflow-empresa-diseno-list-page';
import WorkflowEmpresaDisenoPage from './workflow-empresa/workflow-empresa-diseno-page';
import NodosPage from './nodos/nodos-page';
import NodosFormPage from './nodos/nodos-form-page';
import WorkflowEmpresaActividadPage from './workflow-empresa-actividad/workflow-empresa-actividad-page';
import WorkflowEmpresaActividadFormPage from './workflow-empresa-actividad/workflow-empresa-actividad-form-page';
import InstanciasWorkflowPage from './instancias-workflow/instancias-workflow-page';
import InstanciasWorkflowFormPage from './instancias-workflow/instancias-workflow-form-page';
import InstanciasNodosPage from './instancias-nodos/instancias-nodos-page';
import InstanciasNodosFormPage from './instancias-nodos/instancias-nodos-form-page';

const tiles: TileItem[] = [
  { key: 'clase', label: 'Clase', icon: <FaLayerGroup />, color: '#6366f1' },
  { key: 'definicion-workflow', label: 'Definición Workflow', icon: <FaSitemap />, color: '#3b82f6' },
  { key: 'nodos', label: 'Nodos', icon: <FaCircle />, color: '#10b981' },
  { key: 'instancias-workflow', label: 'Instancias de Workflow', icon: <FaStream />, color: '#f59e0b' },
  { key: 'instancias-nodos', label: 'Instancias de Nodos', icon: <FaDotCircle />, color: '#ef4444' },
  { key: 'tipos-actividad', label: 'Tipos de Actividad', icon: <FaTags />, color: '#8b5cf6' },
  { key: 'actividad-empresa', label: 'Actividad Empresa', icon: <FaBuilding />, color: '#0ea5e9' },
  { key: 'workflow-empresa', label: 'Workflow Empresa', icon: <FaNetworkWired />, color: '#14b8a6' },
  { key: 'workflow-empresa-diseno', label: 'Workflow Empresa Diseño', icon: <FaPencilRuler />, color: '#f97316' },
  { key: 'workflow-diseno', label: 'Workflow Diseño', icon: <FaDraftingCompass />, color: '#ec4899' },
  { key: 'workflow-empresa-actividad', label: 'Workflow Empresa Actividad', icon: <FaLink />, color: '#84cc16' },
  { key: 'workflow-status', label: 'Workflow Status', icon: <FaToggleOn />, color: '#06b6d4' },
  { key: 'instancia-actividad-empresa', label: 'Instancia Actividad Empresa', icon: <FaClipboardCheck />, color: '#a855f7' },
  { key: 'categoria-actividad', label: 'Categoría de Actividad', icon: <FaFolderOpen />, color: '#f59e0b' },
];

function WorkflowIndex() {
  const navigate = useNavigate();

  return (
    <div style={s.page}>
      <Breadcrumb items={[
        { label: 'Inicio', to: '/', icon: <FaHome /> },
        { label: 'Configuración', to: '/configuracion', icon: <FaCog /> },
        { label: 'Workflow', icon: <FaProjectDiagram /> },
      ]} />

      <div style={s.header}>
        <div style={{ ...s.iconBox, background: '#10b981' }}>
          <FaProjectDiagram style={s.icon} />
        </div>
        <div>
          <h2 style={s.title}>Workflow</h2>
          <p style={s.subtitle}>Configuración de workflow</p>
        </div>
      </div>

      <TileContainer
        tiles={tiles}
        onSelect={key => navigate(`/configuracion/workflow/${key}`)}
        columnMinWidth={160}
      />
    </div>
  );
}

function SubPage({ tileKey }: { tileKey: string }) {
  const tile = tiles.find(t => t.key === tileKey)!;

  return (
    <div style={s.page}>
      <Breadcrumb items={[
        { label: 'Inicio', to: '/', icon: <FaHome /> },
        { label: 'Configuración', to: '/configuracion', icon: <FaCog /> },
        { label: 'Workflow', to: '/configuracion/workflow', icon: <FaProjectDiagram /> },
        { label: tile.label, icon: tile.icon },
      ]} />

      <div style={s.header}>
        <div style={{ ...s.iconBox, background: tile.color }}>
          <span style={s.icon}>{tile.icon}</span>
        </div>
        <div>
          <h2 style={s.title}>{tile.label}</h2>
          <p style={s.subtitle}>Configuración de {tile.label.toLowerCase()}</p>
        </div>
      </div>

      <div style={s.placeholder}>
        <span style={{ fontSize: 32, color: '#cbd5e1' }}>{tile.icon}</span>
        <p style={{ margin: 0, color: '#94a3b8', fontSize: 14 }}>
          Configuración de <strong>{tile.label}</strong>
        </p>
      </div>
    </div>
  );
}

export default function WorkflowConfigPage() {
  return (
    <Routes>
      <Route path="/" element={<WorkflowIndex />} />
      <Route path="/clase" element={<ClasePage />} />
      <Route path="/clase/new" element={<ClaseFormPage />} />
      <Route path="/clase/:id/edit" element={<ClaseFormPage />} />
      <Route path="/definicion-workflow" element={<WorkflowDefPage />} />
      <Route path="/definicion-workflow/new" element={<WorkflowDefFormPage />} />
      <Route path="/definicion-workflow/:id/edit" element={<WorkflowDefFormPage />} />
      <Route path="/definicion-workflow/:id/diseno" element={<WorkflowDisenoPage />} />
      <Route path="/nodos" element={<NodosPage />} />
      <Route path="/nodos/new" element={<NodosFormPage />} />
      <Route path="/nodos/:id/edit" element={<NodosFormPage />} />
      <Route path="/instancias-workflow"      element={<InstanciasWorkflowPage />} />
      <Route path="/instancias-workflow/new"  element={<InstanciasWorkflowFormPage />} />
      <Route path="/instancias-nodos" element={<InstanciasNodosPage />} />
      <Route path="/instancias-nodos/:id/edit" element={<InstanciasNodosFormPage />} />
      <Route path="/tipos-actividad" element={<TipoActividadPage />} />
      <Route path="/tipos-actividad/new" element={<TipoActividadFormPage />} />
      <Route path="/tipos-actividad/:id/edit" element={<TipoActividadFormPage />} />
      <Route path="/actividad-empresa" element={<SubPage tileKey="actividad-empresa" />} />
      <Route path="/workflow-empresa" element={<WorkflowEmpresaPage />} />
      <Route path="/workflow-empresa/new" element={<WorkflowEmpresaFormPage />} />
      <Route path="/workflow-empresa/:id/edit" element={<WorkflowEmpresaFormPage />} />
      <Route path="/workflow-empresa/:id/diseno" element={<WorkflowEmpresaDisenoPage />} />
      <Route path="/workflow-empresa-diseno" element={<WorkflowEmpresaDisenoListPage />} />
      <Route path="/workflow-diseno" element={<WorkflowDisenoListPage />} />
      <Route path="/workflow-diseno/new" element={<WorkflowDisenoFormPage />} />
      <Route path="/workflow-diseno/:id/edit" element={<WorkflowDisenoFormPage />} />
      <Route path="/workflow-empresa-actividad" element={<WorkflowEmpresaActividadPage />} />
      <Route path="/workflow-empresa-actividad/:id/edit" element={<WorkflowEmpresaActividadFormPage />} />
      <Route path="/workflow-status" element={<SubPage tileKey="workflow-status" />} />
      <Route path="/instancia-actividad-empresa" element={<SubPage tileKey="instancia-actividad-empresa" />} />
      <Route path="/categoria-actividad" element={<CategoriaActividadPage />} />
      <Route path="/categoria-actividad/new" element={<CategoriaActividadFormPage />} />
      <Route path="/categoria-actividad/:id/edit" element={<CategoriaActividadFormPage />} />
    </Routes>
  );
}

const s: Record<string, React.CSSProperties> = {
  page: { display: 'flex', flexDirection: 'column', gap: 28 },
  header: { display: 'flex', alignItems: 'center', gap: 14 },
  iconBox: { width: 48, height: 48, borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 },
  icon: { fontSize: 22, color: '#fff', display: 'flex' },
  title: { margin: 0, fontSize: 22, fontWeight: 700, color: '#0f172a' },
  subtitle: { margin: 0, fontSize: 13, color: '#64748b' },
  placeholder: { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 12, padding: '48px 24px', background: '#fff', border: '1px dashed #e2e8f0', borderRadius: 12 },
};
